
///
/// EarthBrowser Design System - Spacing & Layout
///
/// Centralized spacing, margins, and layout constants
/// Reference: documentation/DESIGN_SYSTEM.md
///

export class DesignSpacing {
	// Border radius (following Tailwind convention)
	static readonly RADIUS_3XL = 24  // rounded-3xl
	static readonly RADIUS_2XL = 16  // rounded-2xl
	static readonly RADIUS_XL = 12   // rounded-xl
	static readonly RADIUS_LG = 8    // rounded-lg
	static readonly RADIUS_MD = 6    // rounded-md
	static readonly RADIUS_SM = 4    // rounded-sm

	// Standard margins
	static readonly MARGIN_LARGE = 20
	static readonly MARGIN_STANDARD = 16
	static readonly MARGIN_MEDIUM = 12
	static readonly MARGIN_SMALL = 10
	static readonly MARGIN_TINY = 8
	static readonly MARGIN_CLOSE_BUTTON = 8

	// Vertical spacing between elements
	static readonly SPACING_TITLE = 22      // After title/heading
	static readonly SPACING_SECTION = 20    // Between sections
	static readonly SPACING_ITEM = 18       // Between items
	static readonly SPACING_COMPACT = 16    // Compact spacing
	static readonly SPACING_FIELD = 30      // Between data fields
	static readonly SPACING_FIELD_COMPACT = 28  // Between compact data fields

	// Panel dimensions (common sizes)
	static readonly PANEL_WIDTH_STANDARD = 270
	static readonly PANEL_WIDTH_WIDE = 320
	static readonly PANEL_WIDTH_NARROW = 220

	// Screen margins
	static readonly SCREEN_MARGIN = 20
	static readonly SCREEN_MARGIN_SMALL = 10

	// Connector line offsets
	static readonly CONNECTOR_OFFSET = 30

	// Position smoothing
	static readonly SMOOTH_FACTOR = 0.35
	static readonly POSITION_THRESHOLD = 15
}
